var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "py-4 pt-0"
  }, [_c('v-dialog', {
    staticClass: "dialog",
    attrs: {
      "transition": "dialog-bottom-transition",
      "width": "550",
      "scrollable": ""
    },
    model: {
      value: _vm.$store.state.chat.aberto,
      callback: function callback($$v) {
        _vm.$set(_vm.$store.state.chat, "aberto", $$v);
      },
      expression: "$store.state.chat.aberto"
    }
  }, [_c('v-card', {
    attrs: {
      "max-height": "1000",
      "color": "transparent"
    }
  }, [_c('v-toolbar', {
    staticClass: "rounded-t-xl",
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-avatar', {
    staticClass: "mr-2",
    attrs: {
      "size": "36"
    }
  }, [_c('img', {
    attrs: {
      "src": "/img/mila.png",
      "alt": "Mila"
    }
  })]), _c('v-toolbar-title', [_vm._v("Olá, eu sou a Mila!")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.$store.state.chat.aberto = false;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('ml-chat', {
    staticClass: "ml-chat elevation-7 rounded-b-xl"
  })], 1)], 1), _vm.$route.meta.chat ? _c('v-badge', {
    staticClass: "botao-ajuda",
    attrs: {
      "value": _vm.$store.state.chat.mensagens,
      "overlap": "",
      "small": "",
      "avatar": "",
      "color": "primary",
      "offset-x": "15",
      "offset-y": "15"
    },
    scopedSlots: _vm._u([_vm.$store.state.chat.mensagens > 0 ? {
      key: "badge",
      fn: function fn() {
        return [_c('v-avatar', {
          staticClass: "icone-mensagens"
        }, [_vm._v(" " + _vm._s(_vm.$store.state.chat.mensagens) + " ")])];
      },
      proxy: true
    } : null], null, true)
  }, [_c('v-btn', {
    "class": _vm.$vuetify.breakpoint.xs ? 'tamanho-botao-mobile' : 'tamanho-botao-desktop',
    attrs: {
      "color": "primary",
      "dark": "",
      "fab": ""
    },
    on: {
      "click": function click($event) {
        _vm.$store.state.chat.aberto = true;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "35"
    }
  }, [_vm._v(_vm._s(_vm.botao.icone))])], 1)], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };